<template>
    <div class="bottom">
      <div class="bottom-main">
        <div class="bottom-up">
          <div class="bottom-left" v-if="isEnglish == 0">
            <div class="bottom-title">
              联系我们
            </div>
            <div style="width:415px;color:#979797;font-size:14px;line-height:26px;">
              北京市朝阳区安立路68号阳光广场B2座29层
            </div>
            <div style="color:#979797;font-size:14px;line-height:26px;">电话 : ( 86-10 ) 64896300</div>
            <div style="color:#979797;font-size:14px;line-height:26px;">传真 : ( 86-10 ) 64896292</div>
            <div style="color:#979797;font-size:14px;line-height:26px;">邮箱 : hz@huanzhonglaw.com</div>
          </div>
          <div class="bottom-left" v-else>
            <div class="bottom-title">
              Contact us
            </div>
            <div style="width:215px;color:#979797;font-size:14px;line-height:26px;">
              29Fl, Building B2, Sunshine Plaza, No.68 An Li Road, Chaoyang District, Beijing 100101, China
            </div>
            <div style="color:#979797;font-size:14px;line-height:26px;">Phone : ( 86-10 ) 64896300</div>
            <div style="color:#979797;font-size:14px;line-height:26px;">Fax : ( 86-10 ) 64896292</div>
            <div style="color:#979797;font-size:14px;line-height:26px;">Email : hz@huanzhonglaw.com</div>
          </div>
          <div class="bottom-left" v-if="isEnglish == 0">
            <div class="bottom-title">
              关于环中
            </div>
            <div class="mid-label" v-on:click="aboutUs">关于我们</div>
            <div class="mid-label" v-on:click="anli">典型案例</div>
            <!--<div class="mid-label" v-on:click="hzlx">环中咨询</div>-->
            <!--<div class="mid-label" v-on:click="contactUs">联系我们</div>-->
          </div>
          <div class="bottom-left" v-else>
            <div class="bottom-title">
              About us
            </div>
            <div class="mid-label" v-on:click="aboutUs">About us</div>
            <div class="mid-label" v-on:click="anli">Typical Cases</div>
            <!--<div class="mid-label" v-on:click="hzlx">环中咨询</div>-->
            <!--<div class="mid-label" v-on:click="contactUs">联系我们</div>-->
          </div>
          <div class="bottom-left">
            <div class="bottom-title" v-if="isEnglish == 0">
              业务领域
            </div>
            <div class="bottom-title" v-else>
              Practices
            </div>
            <div class="bottom-lyitem" style="overflow:hidden;    width: 500px;">
              <div v-for="(el, index) in hzywlyArr" :key="`lyitem_${index}`" class="lyitem" v-on:click="clickHZLY(index)">
                {{el.titile}}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-bottom" v-if="isEnglish == 0">
          <div style="float:left;height:75px;color:#a7a7a7;line-height:75px;font-size:14px;">北京市环中律师事务所 <a href="http://www.beian.miit.gov.cn/" target="_blank"><span style="color:#FFFFFF;">京ICP号:05054376</span></a></div>
          <div style="float:right;height:75px;color:#a7a7a7;line-height:75px;font-size:14px;">
            <span style="cursor:pointer;" v-on:click="sm(1)">法律声明</span> | <span style="cursor:pointer;"
                                                                                 v-on:click="sm(2)">免责声明</span> |
            <!--<span style="cursor:pointer;" v-on:click="sm(3)">使用条款</span> |-->
            <span style="cursor:pointer;"  v-on:click="contactUs">联系我们</span>
          </div>
        </div>
        <div class="bottom-bottom" v-else>
          <div style="float:left;height:75px;color:#a7a7a7;line-height:75px;font-size:14px;">Beijing Huan Zhong law firm 京ICP号 :
            05054376</div>
          <div style="float:right;height:75px;color:#a7a7a7;line-height:75px;font-size:14px;">
            <span style="cursor:pointer;" v-on:click="sm(1)">Legal declaration</span> | <span style="cursor:pointer;"
                                                                                 v-on:click="sm(2)">Disclaimer</span> |
            <!--<span style="cursor:pointer;" v-on:click="sm(3)">使用条款</span> |-->
            <span style="cursor:pointer;"  v-on:click="contactUs">Contact us</span>
          </div>
        </div>
      </div>
    </div>
</template>
<style scoped lang="scss">
  .bottom{
    height:340px;
    background:#333;
    width:100%;
  }
  @media screen and (min-width: 1800px) {
    .bottom-main {
      width: 1500px;
    }
  }
  @media screen and (max-width: 1799px) {
    .bottom-main {
      width: 1300px;
    }
  }
  @media screen and (max-width: 1438px) {
    .bottom-main {
      width: 1080px;
    }
  }
  .bottom-main{
    height:340px;
    margin:0 auto;
  }
  .bottom-up{
    height:265px;
    border-bottom:1px solid #666;
  }
  .bottom-left{
    display: inline-block;
    vertical-align: top;
    width: 33%;
    height:160px;
    margin-top:40px;
  }
  .bottom-title{
    font-size:20px;
    margin-bottom:30px;
    color: #b69859;
  }
  .mid-label{
    margin-bottom:8px;
    color:#979797;
    font-size:14px;
    cursor:pointer;
  }
  .lyitem{
    float:left;
    width:210px;
    margin-bottom:13px;
    color:#a7a7a7;
    font-size:14px;
    height:14px;
    cursor:pointer;
  }
  .bottom-bottom{
    height:75px;
  }
</style>
<script>
    import $ from "jquery";
    export default{
        data(){
            return{
              hzywlyArr:[],
              url:"http://39.107.74.88:8080/project/SearchInfoController/getDbHzywlyData",
              isEnglish:window.isEnglish,
            }
        },
        components:{

        },
        methods:{
          // 环中业务领域
          initHZYWLY:function(){
            var _this = this;
            $.ajax({
              type: 'POST',
              url: _this.url,
              dataType: 'json',
              data:{
                type:_this.isEnglish
              },
              success: function(res){
                _this.hzywlyArr = res.data;
              },
            })
          },
          aboutUs:function(){
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(1).css({
            //  "background":"darkgray"
            //})
            sessionStorage.setItem('clickIndex', '0')
            this.$router.push({path:'/about', query:{id:"0"}});
          },
          contactUs:function(){
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(7).css({
            //  "background":"darkgray"
            //})
            sessionStorage.setItem('clickIndex', '7')
            this.$router.push({path:'/contact', query:{id:"0"}});
          },
          clickHZLY:function(index){
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(2).css({
            //  "background":"darkgray"
            //})
            sessionStorage.setItem('clickIndex', '2')
            $('html, body').animate({
              scrollTop: 0
            }, 500);
            this.$router.push({path:'/hzly', query:{id:this.hzywlyArr[index].id}});
          },
          anli:function(){
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(4).css({
            //  "background":"darkgray"
            //})
            sessionStorage.setItem('clickIndex', '4')
            $('html, body').animate({
              scrollTop: 0
            }, 500);
            this.$router.push({path:'/hzyj', query:{id:1}});
          },
          hzlx:function(){
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(1).css({
            //  "background":"darkgray"
            //})
            sessionStorage.setItem('clickIndex', '1')
            $('html, body').animate({
              scrollTop: 0
            }, 500);
            this.$router.push({path:'/about', query:{id:2}});
          },
          sm:function(index){
            $(".header-btn").css({
              "background":""
            })
            //$(".header-btn").eq(7).css({
            //  "background":"darkgray"
            //})
            sessionStorage.setItem('clickIndex', '7')
            $('html, body').animate({
              scrollTop: 0
            }, 500);
            this.$router.push({path:'/contact', query:{id:index}});
          }
        },
        mounted:function(){
          this.initHZYWLY();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/components/bottom.vue